import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils'

type Props = {
  size?: number | string
}

export const AuroraSelfCareResourcesSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 96 96' fill='none'>
      <Rect width='96' height='96' rx='48' fill='white' fillOpacity='0.4' />
      <Path
        d='M59.3117 29.8721H29.2547C27.3784 29.8721 25.8574 31.3931 25.8574 33.2693V55.5051C25.8574 57.3813 27.3784 58.9024 29.2547 58.9024H59.3117C61.188 58.9024 62.709 57.3813 62.709 55.5051V33.2693C62.709 31.3931 61.188 29.8721 59.3117 29.8721Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M40.3867 37.4326V51.3419C40.3867 51.9956 41.1329 52.372 41.6578 51.9824L51.044 45.0261C51.4732 44.7091 51.4732 44.0654 51.044 43.7484L41.6578 36.7921C41.1329 36.4025 40.3867 36.7789 40.3867 37.4326Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M70.7051 58.8891H51.3647C50.1795 58.8891 49.2188 57.9284 49.2188 56.7432C49.2188 55.5579 50.1795 54.5972 51.3647 54.5972H70.7051C71.8903 54.5972 72.851 55.5579 72.851 56.7432C72.851 57.9284 71.8903 58.8891 70.7051 58.8891Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M70.7051 66.4233H51.3647C50.1795 66.4233 49.2188 65.4626 49.2188 64.2773C49.2188 63.0921 50.1795 62.1313 51.3647 62.1313H70.7051C71.8903 62.1313 72.851 63.0921 72.851 64.2773C72.851 65.4626 71.8903 66.4233 70.7051 66.4233Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M70.7051 73.9604H51.3647C50.1795 73.9604 49.2188 72.9997 49.2188 71.8144C49.2188 70.6292 50.1795 69.6685 51.3647 69.6685H70.7051C71.8903 69.6685 72.851 70.6292 72.851 71.8144C72.851 72.9997 71.8903 73.9604 70.7051 73.9604Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
